/**
 * Constantes de configuración de la aplicación
 * 
 * Centraliza valores importantes como:
 * - Configuración general de la app
 * - Tipos de usuario disponibles
 * - Vistas/rutas de navegación
 * - Estados de conexión
 * - Probabilidades de matching
 */

// Configuración general de la aplicación
export const APP_CONFIG = {
  NAME: 'RacksMatch',
  TAGLINE: 'Entrepreneur & Investor Networking Platform',
  DEFAULT_LOCATION: 'San Francisco, CA',
  SWIPE_THRESHOLD: 100, // Píxeles necesarios para activar swipe
  CONNECTION_PROBABILITY: {
    NORMAL: 0.4,      // 40% probabilidad de match normal
    SUPER_LIKE: 0.7   // 70% probabilidad de match con super like
  }
} as const;

// Tipos de usuario disponibles en la plataforma
export const USER_TYPES = {
  ENTREPRENEUR: 'entrepreneur',
  INVESTOR: 'investor'
} as const;

// Vistas/pantallas disponibles en la aplicación
export const ROUTES = {
  HOME: '/',                         // Vista principal de tarjetas (swipe)
  CONVERSATIONS: '/conversations',    // Lista de conversaciones
  CHAT: '/chat/:id',                 // Chat individual con ID de conversación
  PROFILE: '/profile',               // Edición de perfil
  CREATE_PROJECT: '/create-project'  // Crear nuevo proyecto
} as const;

// Estados posibles de una conexión entre usuarios
export const CONNECTION_STATUS = {
  PENDING: 'pending',
  ACCEPTED: 'accepted',
  MEETING_SCHEDULED: 'meeting-scheduled'
} as const;